import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import "./bookings.scss";

function ViewBooking() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const breadcrumbItems = [
    { title: "Bookings", link: "#" },
    { title: "View Booking", link: "#" },
  ];

  useEffect(() => {
    fetchBookingById();
  }, [id]);

  const fetchBookingById = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/bookings/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched booking:", data);

      // Handle API response with different structures
      if (data.booking) {
        setBooking(data.booking);
      } else {
        setBooking(data);
      }
    } catch (error) {
      console.error("Error fetching booking:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">Loading booking details...</div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center text-danger">Error: {error}</div>
        </Container>
      </div>
    );
  }

  if (!booking) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">No booking details found.</div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="View Booking" breadcrumbItems={breadcrumbItems} />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Customer Name</Label>
                        <Input type="text" value={booking.customer_name || ""} disabled />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Email</Label>
                        <Input type="email" value={booking.customer_email || ""} disabled />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Tour Name</Label>
                        <Input
                          type="text"
                          value={booking.tour?.tour_name || ""}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Tour Duration</Label>
                        <Input
                          type="text"
                          value={booking.tour?.duration || ""}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>From Date</Label>
                        <Input
                          type="text"
                          value={
                            booking.from_date
                              ? new Date(booking.from_date).toLocaleDateString()
                              : ""
                          }
                          disabled
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Time</Label>
                        <Input type="text" value={booking.time || ""} disabled />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Adults</Label>
                        <Input type="number" value={booking.adults || 0} disabled />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Children</Label>
                        <Input type="number" value={booking.children || 0} disabled />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Infants</Label>
                        <Input type="number" value={booking.newborns || 0} disabled />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Total Price</Label>
                        <Input type="text" value={booking.total_price || ""} disabled />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Status</Label>
                        <Input type="text" value={booking.status || ""} disabled />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <Label>Notes</Label>
                    <Input
                      type="textarea"
                      rows="3"
                      value={booking.notes || ""}
                      disabled
                    />
                  </FormGroup>

                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      color="secondary"
                      onClick={() => navigate("/bookings")}
                    >
                      Back to List
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ViewBooking;
